import React from 'react';

import { CheckIcon } from '@heroicons/react/24/solid';
import { Avatar } from '@mui/material';

interface Props {
  primary: React.ReactNode;
  secondary?: React.ReactNode;
}

const ListInfoItem: React.FC<Props> = (props) => {
  const { primary, secondary } = props;
  return (
    <div className="flex gap-3">
      <Avatar className="w-6 h-6 bg-darkblue-800 flex-shrink-0">
        <CheckIcon className="h-4" />
      </Avatar>
      <div className="space-y-1">
        <h4 className="font-bold">{primary}</h4>
        <h5 className="text-gray-400">{secondary}</h5>
      </div>
    </div>
  );
};

export default ListInfoItem;
